import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionDatacenter.mp4",
    poster: "/images/solutions/solutionDatacenter.jpg",
    heading: "Designing and developing data centers for what is not yet imagined",
    subheading: "With the potential to be the transformative technology of our generation, we’re creating DCI solutions to ensure AIs potential and impact are limitless.",
    buttonLink: "/solutions"
  }
];

const facts = [
    { label: "Staff execution", value: 36, prefix: "", suffix: "%", key: "years" },
    { label: "Insufficient staff", value: 28, prefix: "", suffix: "%", key: "continents" },
    { label: "Incorrect procedures", value: 21, prefix: "", suffix: "%", key: "employees" },
  ];

  const data = [
  {
    title: "Data Center Infrastructure Management",
    items: [
      { q: "How does fiber optic infrastructure support cloud computing?", a: "Fiber optic infrastructure supports cloud computing by providing high-speed, reliable connections between data centers and cloud service providers, enabling fast data transfer and low latency for cloud-based applications." },
      { q: "How does fiber optic infrastructure contribute to data center sustainability?", a: "Fiber optics reduce energy consumption (due to lower signal loss and fewer repeaters), support virtualization and cloud computing (which reduce the need for physical hardware), and enable efficient cooling (one of the highest energy drivers) through better cable management." },
      { q: "Why is fiber optic cable preferred in data centers?", a: "Fiber optic cables are preferred in data centers due to their high bandwidth capacity, long-distance transmission capabilities, low latency, and immunity to electromagnetic interference (EMI)." },
      { q: "What are the challenges of implementing fiber optic infrastructure in data centers?", a: "Challenges include cost (initial installation and maintenance), physical space requirements for cable management, and the need for skilled personnel to handle installation and troubleshooting." },
      { q: "How do you upgrade fiber optic infrastructure in data centers?", a: "Upgrading involves assessing current infrastructure, planning for higher capacity cables and connectors, implementing new technologies like DWDM, and ensuring minimal downtime during the transition." },
      { q: "How do you ensure proper cable management in data centers?", a: "Proper cable management involves using cable trays, raceways, cable ties, and labeling systems to organize and secure cables. This helps in maintaining airflow, preventing damage, and makes maintenance easier, quicker, and mitigates human error.." },
      { q: "What is the importance of fiber optic testing in data centers?", a: "Fiber optic testing is crucial for ensuring the integrity and performance of the network. Testing assesses continuity, attenuation, back reflection, and fiber end-face cleanliness, helping teams identify and rectify any performance issues." },
      { q: "How do you prevent fiber optic cable damage in data centers?", a: "Preventing damage involves using protective conduits, fiber optic enclosures, adhering to proper bending radius guidelines, and secure fiber cable routing to avoid physical stress and environmental damage." },
      { q: "How is fiber optic cable terminated in data centers?", a: "Fiber optic cables are terminated using connectors that are attached to the end of the fibers. Cable termination can be done using various methods, such as fusion splicing, mechanical splicing, or pre-terminated solutions." },
      { q: "What is the expected lifespan of fiber optic cables in data centers?", a: "The lifespan of fiber optic cables can vary, but they typically last 20-25 years or more, provided they are properly installed and maintained, as they are less susceptible to environmental degradation compared to copper cables." },
    ],
  },
  {
    title: "Data Center Layer 1 Technology",
    items: [
      { q: "What are the types of fiber optic cables used in data centers?", a: "You’ll find single-mode fiber (SMF) and multi-mode fiber (MMF) in data centers. Single-mode fiber is used for long-distance communication, while multi-mode fiber is used for shorter distances within the data center." },
      { q: "What are the common connectors used in data center fiber infrastructure?", a: "Common connectors include LC, SC, ST, and MTP/MPO (Multi-Fiber Push-On/Pull-Off). LC and MTP/MPO connectors are popular due to their compact size and ability to handle high-density connections." },
      { q: "What do fiber patch panels do in data centers?", a: "Fiber patch panels organize and manage the connections between incoming and outgoing fiber optic cables. They provide a centralized point for connecting and disconnecting cables, making it easier to make changes to or troubleshoot the network. Unlike splicing connections, these semi-permanent patched connections provide scalability and sustainability by leveraging dense fiber connectivity while requiring minimal configuration changes to support growth and longevity in the data center." },
      { q: "What is DWDM and how is it used in data centers?", a: "Dense Wavelength Division Multiplexing (DWDM) is a technology that combines multiple wavelengths of light on a single fiber, significantly increasing the capacity of the fiber infrastructure. It’s used to maximize the bandwidth in data center interconnects." },
      { q: "What is the role of fiber in a data center interconnect (DCI)?", a: "Fiber plays a critical role in Data Center Interconnect (DCI) by enabling high-capacity, low-latency communication between geographically dispersed data centers, supporting disaster recovery, load balancing, and data replication." },
      { q: "What are the advantages of Spreadable Adapter technology?", a: "There are many benefits of using spreadable adapters including: Improved cable organization and management. Spreadable adapters enable easy connector access to any adapter in any row without affecting insertion loss and instant port identification with easy access makes moves, adds, & changes in high fiber density environments manageable, Flexibility in arranging connections. Adaptive cassette design allows for a variety of optical components to be used to get the maximum platform utility, Reduced maintenance and troubleshooting time. Backside adapter maintenance can be done from the front of the chassis, and scalability and futureproofing. Port count can scale within the cassette for custom density and there is no need to remove cables and panels when making upgrades" },
    ],
  },
];

const posts = [
  {
      id: "01",
      category: "Infrastructure",
      tags: ["AI"],
      title: "Connectivity Guide to AI Data Center Terminology",
      date: "04 / 21 / 2026",
      excerpt: "A glossary of terms to help demystify acronyms, terminology, and decode general AI data center language.",
      img: "/images/blog/aiTerminology.jpeg",
      url: "https://gofoton.com/connectivity-guide-to-ai-data-center-terminology"
    },
  {
      id: "02",
      category: "Infrastructure",
      tags: ["AI", "Data Centers"],
      title: "The Networking Skilled Labor Gap: The realities and remedies",
      date: "02 / 25 / 2026",
      excerpt: "In the last 2 years, just about every conversation I have regarding network infrastructure new builds and installations always lead to the same question, “Where are you finding quality technicians and engineers right now?”.",
      img: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FBlogSkilledLabor.jpeg?alt=media&token=a6258f5f-6e1c-4616-8f6c-8c39eb65776c",
      url: "https://gofoton.com/the-networking-skilled-labor-gap"
    },
    {
      id: "03",
      category: "Fiber Basics",
      tags: ["AI", "Data Centers", "Connectivity"],
      title: "Ask the expert: Your cable assembly questions answered by Go!Foton",
      date: "12 / 02 / 2025",
      excerpt: "Technology in the network physical layer is changing at a pace greater than ever before. New applications like AI are driving higher and higher data rates, creating a cascade of upgrades and ripple effects throughout the technology stack.",
      img: "/images/blog/cablesBlog.jpeg",
      url: "https://gofoton.com/cable-assembly-questions-answered"
    },
    {
      id: "04",
      category: "Infrastructure",
      tags: ["Single-Mode", "Multi-Mode", "Hardware"],
      title: "The Importance of Fiber Density in AI Data Centers",
      date: "09 / 13 / 2024",
      excerpt: "Fiber optics serve as the backbone of modern networks, connecting critical equipment and software. In AI data centers, fiber-dense infrastructure is essential for supporting the high bandwidth, low-latency, and scalable data transmission these environments demand. ",
      img: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FEVA_16F-MMF_2x8_MPO-DXLCU_FA_with-cover.png?alt=media&token=1da6fccb-b00d-4ea1-a8c3-69984db328a3",
      url: "https://www.gofoton.com/the-importance-of-fiber-density-in-ai-data-centers/" 
    }
  ];

const rows = [
  {
    need: "More density to support more capacity and speeds",
    feature: "Spreadable adapters allow for more terminations",
    benefit: "Increase capacity within the same amount of real estate",
  },
  {
    need: "Easy and quick moves, adds, changes and troubleshooting",
    feature: "Labeling viewable from all angles",
    benefit: "Save time, money, minimizes mistakes, increases uptime",
  },
  {
    need: "A solution to scale",
    feature: "Modular solutions that support preterminated trunk cables",
    benefit: "Add capacity as needed",
  },
  {
    need: "Higher speed connections (100G, 400G, 800G)",
    feature:
      "Supports 4x10 Gbps, 100 Gbps, 2x100 Gbps, 4x100 Gbps, 400 Gbps, 2x400 Gbps, 4x400 Gbps breakout requirements",
    benefit:
      "Grow with technology without replacing the backbone",
  },
  {
    need: "A large amount of product, quickly",
    feature: "Build to forecast and warehouse in the USA",
    benefit: "Purchase and get product when you need it",
  },
  {
    need: "To manage my technical staff shortages",
    feature: "Offer rack and stack services",
    benefit: "Simplify installation and speed turn-up",
  },
  {
    need: "A second supplier",
    feature: "Meet performance with short lead times",
    benefit: "Stay on schedule and minimize risk",
  },
  {
    need: "Sustainable solutions",
    feature: "High density products use less materials",
    benefit: "Support green initiatives",
  },
  {
    need: "Design & installation services",
    feature:
      "Full-service project management, design & engineering, installation, and testing & turn-up services",
    benefit:
      "One vendor to manage your network projects, beginning to end",
  },
];


function SolutionDatacenter() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [open, setOpen] = useState(new Set());

  const toggle = (key) => {
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  const [startIndex, setStartIndex] = useState(0);

  const next = () => {
    if (startIndex + 3 < topByFamily.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };


const productFamilies = [
  'Fiber Cable Assemblies',
  'Cassettes',
  'Frames',
  'Fiber Panels',
  //'Fiber Splice Chassis'
];

    const [counts, setCounts] = useState({
      years: 0,
      continents: 0,
      employees: 0,
    });

      useEffect(() => {
        const animationFrames = {};
        const durations = 600; // in ms
    
        facts.forEach(fact => {
          const start = performance.now();
    
          const animate = now => {
            const progress = Math.min((now - start) / durations, 1);
            const currentValue = Math.floor(progress * fact.value);
    
            setCounts(prev => ({
              ...prev,
              [fact.key]: currentValue,
            }));
    
            if (progress < 1) {
              animationFrames[fact.key] = requestAnimationFrame(animate);
            }
          };
    
          animationFrames[fact.key] = requestAnimationFrame(animate);
        });
    
        return () => {
          Object.values(animationFrames).forEach(cancelAnimationFrame);
        };
      }, []);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

const toSlug = str => str.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const topByFamily = [
  {
    family: 'Services',
    slug: '/services',
    topProduct: null
  },
  ...productFamilies.map(famName => {
    const matchingProducts = filteredProducts.filter(
      p => (p.productFamily || '').trim() === famName
    );
    if (matchingProducts.length === 0) return null;

    const topProduct = matchingProducts.reduce((best, current) =>
      Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
    );

    return {
      family: famName,
      slug: toSlug(famName),
      topProduct
    };
  }).filter(Boolean)
];

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};


useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page"> 
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={'/support'} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1" style={{ marginTop: 30}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/services/image3.jpg" alt="Datacenter" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Hey, data center – deliver more, faster!</h2>
          <p className="solution-section-1-description" style={{marginBottom: 40}}>Data center managers have been trying to keep pace with unprecedented and relentless capacity growth. On top of online services, IoT, cloud computing, cloud storage, and 5G, AI demands extraordinary computing power and connectivity.<br/><br/>

The number of devices in data centers (servers, switches, routers) has increased. And architectures are evolving to “spine and leaf” to meet the low-latency requirements of data-intense applications.<br/><br/>

This results in a need for more space, more aggregation points, and versatile connectivity solutions to handle the needed density and number of connections. All while executing under tight deadlines and short cycle times, without disruption to the customer experience.</p>
                 <a
  href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/brochures%2FDatacenter%20Brochure.pdf?alt=media&token=9a14df6a-2945-472d-8ef8-ddf39a540b6c"
  className="cta-button"
  target="_blank"
  rel="noopener noreferrer"
>            DOWNLOAD THE BROCHURE
          </a>    
       
        </div>

      </div>

      <FactoidSection
        solution="datacenter"
        title="Research estimates AI will have a massive impact on data centers"
        description=""
      />

    


      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/services/image5.jpg" alt="Central Office" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <h2 className="solutions-section-checklist-heading">Data center infrastructure is as critical as our circulatory system</h2>
          <p className="solutions-section-checklist-description">While the cost of connectivity may be fractional compared to real estate, HVAC, power, or servers, connectivity is just as essential ingredient to data center operations. Connectivity enables the information flow and ultimately the consumer experience. Making the right choice impacts your ability to:</p>
          <ul className="solutions-section-checklist-points">
            <li>Scale operations, adding network capacity with turnkey, end-to-end solutions</li>
            <li>Manage fiber density by creating more space</li>
            <li>Easily manage and operate their network with clear cable management and port identification</li>
            <li>Enable customization with versatile cutting-edge technologies</li>
            <li>Turn-up service quickly with readily available and short lead-time products</li>
            <li>Create or break out high-speed connections (100G, 400G, 800G)</li>
          </ul>
        </div>
      </div>


      <div className="solutions-section-alignRight" style={{ backgroundColor: '#f8f8f8'}}>
  <div
    className="solutions-section-alignRight-text-container"
    style={{
      display: 'flex',
      flexDirection: 'column', // makes alignSelf work
      alignItems: 'flex-end',  // aligns all content to the right
      marginTop: 90,
      marginBottom: 50
    }}
  >
    <h2 className="solutions-section-alignRight-subheading">
      Turnkey services from design to deployment
    </h2>
    <p className="solution-section-alignRight-description">
      Bring your data center builds from concept to reality faster and more efficiently.
    </p>
    <a
      className="cta-button"
      style={{ marginTop: 20, alignSelf: 'flex-end' }}
      href="/services"
    >
      Our Services
    </a>
</div>


        <div className="solutions-section-alignRight-image-container">
          <img src="/images/services/image7.jpg" alt="Datacenter" />
        </div>
      </div>

      <div className="solutions-section-centeredText" style={{ backgroundColor: '#f8f8f8', position: 'relative'}}>
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Your connectivity choices add-up to save time and money</h2>
          <p className="solution-section-centeredText-description">Connectivity has the power to create space in a fast-growing environment where real estate is at a premium. Connectivity has the power to simplify the complexity of networks, making it easier for staff to find and work with equipment. And the easier all of this is, the quicker it is to add revenue-producing services or keep the network up when actions or failed equipment bring it down.</p>
        


       <div className="solutions-icon-grid-2">
            <div className="icon-item">
              <img src="/images/icons/rapidResponse.png" alt="Icon 1" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10}}>Fast delivery​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/fingerprint.webp" alt="Icon 2" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Custom solutions</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/global.webp" alt="Icon 3" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Services & solutions</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/thumbs.webp" alt="Icon 4" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Easy to use</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/lightbulb.png"alt="Icon 5" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Green solutions</p>
            </div>
          </div>

          </div>

          <div className={'curved-divider-bottom'} />
      </div>


    <section className="solution-products-section" style={{ backgroundColor: 'white'}}>
      <h2>Our featured solutions</h2>
      {/* <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p> */}

<div className="article-slider-container">
  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-left ${familyIndex === 0 ? "disabled" : ""}`}
      onClick={prevFamily}
      disabled={familyIndex === 0}
    >
      &#10094;
    </button>
  )}

  <div className="article-slider-viewport">
    <div
      className="article-slider-track"
      style={{
        transform: `translateX(-${familyIndex * (100 / familySlidesPerView)}%)`,
        "--content-slides-per-view": familySlidesPerView,
      }}
    >
      {topByFamily.map((article, idx) => (
        <div className="article-slider-slide" key={idx}>
          <div className="image-slider-card">
            <div className="image-logo-wrapper">
              <img
                src={
                  article.topProduct
                    ? article.topProduct.image
                    : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAI%20Data%20Center%20Image%20(1).jpg?alt=media&token=367424a2-ef6c-4e88-a8dc-8ac186a99ac1"
                }
                alt="logo"
                className="image-logo"
              />
            </div>

            <h3>{article.family}</h3>

            <a
              className="cta-button"
              href={article.topProduct ? `/${article.slug}` : `/services`}
              style={{ textDecoration: "none" }}
            >
              View
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>

  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-right ${familyIndex === familyMaxIndex ? "disabled" : ""}`}
      onClick={nextFamily}
      disabled={familyIndex === familyMaxIndex}
    >
      &#10095;
    </button>
  )}
</div>


<div className="solutions-section-centeredText" style={{ marginTop: 50 }}>
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">According to the Uptime Institute, the most common causes of data center issues are:</h2>
          <div className="factory-facts">
                {facts.map(fact => (
                  <div className="fact" key={fact.key}>
                    <div className="fact-number" style={{ color: "#85246D" }}>
                      {fact.prefix}{counts[fact.key]}{fact.suffix}
                    </div>
                    <div className="fact-label"  style={{color: '#4D4D4F'}}>{fact.label}</div>
                  </div>
                ))}
              </div>
        </div>
      </div>

<div style={{ paddingRight: '2vw', marginTop: 50, paddingLeft: '2vw', alignItems: 'flex-start'}}>
          <h2 style={{ textAlign: 'left'}} className="solutions-section-checklist-heading">Does any of this sound like you?</h2>
          <p style={{ marginTop: -30, marginBottom: 40, color: '#4d4d4f'}} className="solutions-section-checklist-description">Here’s a look at how Go!Foton is designing connectivity to add density and improve its usability. </p>
         </div>

         <img
  src="/images/solutions/datacenterTable.png"
  alt="Datacenter Table"
  className="responsive-image-table"
/>


<div className="fb-table">
      <div className="fb-row fb-header">
        <div className="fb-cell fb-need-header"></div>
        <div className="fb-cell fb-feature-header">Our Feature</div>
        <div className="fb-cell fb-benefit-header">Your Benefit</div>
      </div>

      {rows.map((r, i) => (
        <div className="fb-row" key={i}>
          <div className="fb-cell fb-need">{r.need}</div>
          <div className="fb-cell fb-feature">{r.feature}</div>
          <div className="fb-cell fb-benefit">{r.benefit}</div>
        </div>
      ))}
    </div>


    </section>

    <div className="blog-container">
  <center><h2 className="solutions-section-centeredText-subHeading" style={{ marginBottom: "60px"}}>Recent Blogs</h2></center>

                {/* <center><h2 style={{ textAlign: 'left'}} className="solutions-section-checklist-heading">Recent Blogs</h2></center> */}

      {posts.map((post) => (
        <div key={post.id} className="blog-post-wrapper">
          {/* Ghost Number Background */}
          {/* <div className="ghost-number">{post.id}</div> */}

          {/* Image */}
          <div className="blog-image-box">
            <img src={post.img} alt={post.title} />
          </div>

          {/* Content */}
          <div className="blog-content">
            <span className="category-label">{post.category}</span>
            <div className="tag-container">
              {post.tags.map(tag => (
                <span key={tag} className="pill-tag">{tag}</span>
              ))}
            </div>
            
            <h2 className="blog-title">{post.title}</h2>
            <p className="blog-excerpt">{post.excerpt}</p>

            <div className="blog-footer">
              <span className="blog-date">{post.date}</span>
              <a 
                href={post.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="read-story-btn"
              >
                Read Story
              </a>
            </div>
          </div>
        </div>
      ))}
  <center>
      <a className="cta-button"  href="/knowledge-center">SEE MORE BLOGS</a>
      </center>
    </div>


<section className="faq-wrap">
      {/* <h2 className="faq-title">Answers to Common Questions</h2> */}
      <center>
      <button
        className="accordion-header"
        style={{ width: '90%', marginBottom: 20}}
        //onClick={() => toggleSection('faq')}
      >
        Answers to Common Questions
        <span className="accordion-icon">
        </span>
      </button>
      </center>

      <div className="faq-grid">
        {data.map((section, sIdx) => (
          <div className="faq-col" key={sIdx}>
            <h3 className="faq-col-title" style={{ color: '#4D4D4F'}}>{section.title}</h3>

            <div className="faq-list">
              {section.items.map((item, iIdx) => {
                const key = `${sIdx}-${iIdx}`;
                const isOpen = open.has(key);
                return (
                  <div className={`faq-item ${isOpen ? "open" : ""}`} key={key}>
                    <button
                      className="faq-question"
                      onClick={() => toggle(key)}
                      aria-expanded={isOpen}
                    >
                      <span style={{color: '#4D4D4F'}}>{item.q}</span>
                      <span className="faq-icon">{isOpen ? "–" : "+"}</span>
                    </button>

                    <div
                      className="faq-answer"
                      style={{ maxHeight: isOpen ? "200px" : "0px" }}
                    >
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{ backgroundColor: 'white'}}></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default SolutionDatacenter;
